import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "text-body2",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_iuf_select, _mergeProps({
      onFilter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterOptions({ ...$event }))),
      options: _ctx.valueOptions,
      "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
      "option-label": "label",
      "option-value": "dobjId",
      "selected-item-slot": "",
      "no-option-slot": ""
    }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
      modelValue: _ctx.selectedValues,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValues) = $event))
    }), {
      "no-option": _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CAPTION)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('NO_OPTION')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      "selected-item": _withCtx((scope) => [
        (_openBlock(), _createBlock(_component_iap_chip, {
          tooltip: "",
          label: scope.opt.label,
          key: scope.opt.dobjId,
          removable: "",
          onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
        }, null, 8, ["label", "onRemove"]))
      ]),
      _: 1
    }, 16, ["options", "placeholder-value", "modelValue"])
  ]))
}